import angular from 'angular'

angular.module('nominas.pendientes')
  .config(Config);

function Config($stateProvider) {
  $stateProvider.state('nominas.pendientes.cotizar', {
    reloadOnSearch: false,
    url: '/cotizar?{id_empresa}&{id_nomina}',
    data: {title: 'Cotizar'},
    template: '<nominas-pendientes-cotizar></nominas-pendientes-cotizar>',
  });
}



// WEBPACK FOOTER //
// ./src/nominas/pendientes/routes/nominas.pendientes.cotizar.js